import { copy } from './copy';
import { SelectGroup, SelectOption } from './types';

export const defaultTitleMetadata = 'Black Women in Tech Hub • Platform';
export const defaultMetaDescription =
  'The Black Women in Tech Hub (BWTH) is a pioneering platform committed to addressing the current under-presentation of Black Women in the Technology sector.';

export const timezoneData: SelectGroup[] = [
  {
    groupLabel: 'North America',
    options: [
      { label: 'Toronto (UTC-5)', value: 'America/Toronto' },
      { label: 'Vancouver (UTC-8)', value: 'America/Vancouver' },
      { label: 'Halifax (UTC-4)', value: 'America/Halifax' },
      { label: "St. John's (UTC-3:30)", value: 'America/St_Johns' },
      { label: 'Calgary / Edmonton (UTC-7)', value: 'America/Edmonton' },
      { label: 'Winnipeg (UTC-6)', value: 'America/Winnipeg' },
      { label: 'New York (UTC-5)', value: 'America/New_York' },
      { label: 'Chicago (UTC-6)', value: 'America/Chicago' },
      { label: 'Denver (UTC-7)', value: 'America/Denver' },
      { label: 'Los Angeles (UTC-8)', value: 'America/Los_Angeles' },
      { label: 'Phoenix (UTC-7)', value: 'America/Phoenix' },
      { label: 'Anchorage (UTC-9)', value: 'America/Anchorage' },
      { label: 'Mexico City (UTC-6)', value: 'America/Mexico_City' },
    ],
  },
  {
    groupLabel: 'Europe & Africa',
    options: [
      { label: 'London (UTC+0)', value: 'Europe/London' },
      { label: 'Paris (UTC+1)', value: 'Europe/Paris' },
      { label: 'Berlin (UTC+1)', value: 'Europe/Berlin' },
      { label: 'Madrid (UTC+1)', value: 'Europe/Madrid' },
      { label: 'Rome (UTC+1)', value: 'Europe/Rome' },
      { label: 'Moscow (UTC+3)', value: 'Europe/Moscow' },
      { label: 'Istanbul (UTC+3)', value: 'Europe/Istanbul' },
      { label: 'Amsterdam (UTC+1)', value: 'Europe/Amsterdam' },
      { label: 'Zurich (UTC+1)', value: 'Europe/Zurich' },
      { label: 'Cairo (UTC+2)', value: 'Africa/Cairo' },
      { label: 'Johannesburg (UTC+2)', value: 'Africa/Johannesburg' },
      { label: 'Stockholm (UTC+1)', value: 'Europe/Stockholm' },
    ],
  },
  {
    groupLabel: 'Asia',
    options: [
      { label: 'Tokyo (UTC+9)', value: 'Asia/Tokyo' },
      { label: 'Shanghai (UTC+8)', value: 'Asia/Shanghai' },
      { label: 'Hong Kong (UTC+8)', value: 'Asia/Hong_Kong' },
      { label: 'Singapore (UTC+8)', value: 'Asia/Singapore' },
      { label: 'Kolkata (UTC+5:30)', value: 'Asia/Kolkata' },
      { label: 'Dubai (UTC+4)', value: 'Asia/Dubai' },
      { label: 'Seoul (UTC+9)', value: 'Asia/Seoul' },
      { label: 'Bangkok (UTC+7)', value: 'Asia/Bangkok' },
      { label: 'Jakarta (UTC+7)', value: 'Asia/Jakarta' },
      { label: 'Kuala Lumpur (UTC+8)', value: 'Asia/Kuala_Lumpur' },
    ],
  },
  {
    groupLabel: 'Australia / Oceania',
    options: [
      { label: 'Sydney (UTC+10)', value: 'Australia/Sydney' },
      { label: 'Melbourne (UTC+10)', value: 'Australia/Melbourne' },
      { label: 'Brisbane (UTC+10)', value: 'Australia/Brisbane' },
      { label: 'Auckland (UTC+12)', value: 'Pacific/Auckland' },
    ],
  },
  {
    groupLabel: 'South America',
    options: [
      { label: 'Sao Paulo (UTC-3)', value: 'America/Sao_Paulo' },
      { label: 'Buenos Aires (UTC-3)', value: 'America/Buenos_Aires' },
    ],
  },
];

export const countryData: SelectGroup[] = [
  {
    groupLabel: 'North America',
    options: [
      { label: 'Canada', value: 'Canada' },
      { label: 'United States', value: 'United States' },
      { label: 'Mexico', value: 'Mexico' },
      { label: 'Guatemala', value: 'Guatemala' },
      { label: 'Cuba', value: 'Cuba' },
      { label: 'Dominican Republic', value: 'Dominican Republic' },
      { label: 'Costa Rica', value: 'Costa Rica' },
      { label: 'Panama', value: 'Panama' },
      { label: 'Jamaica', value: 'Jamaica' },
    ],
  },
  {
    groupLabel: 'South America',
    options: [
      { label: 'Brazil', value: 'Brazil' },
      { label: 'Argentina', value: 'Argentina' },
      { label: 'Colombia', value: 'Colombia' },
      { label: 'Chile', value: 'Chile' },
      { label: 'Peru', value: 'Peru' },
      { label: 'Venezuela', value: 'Venezuela' },
      { label: 'Ecuador', value: 'Ecuador' },
      { label: 'Uruguay', value: 'Uruguay' },
    ],
  },
  {
    groupLabel: 'Europe',
    options: [
      { label: 'United Kingdom', value: 'United Kingdom' },
      { label: 'Germany', value: 'Germany' },
      { label: 'France', value: 'France' },
      { label: 'Italy', value: 'Italy' },
      { label: 'Spain', value: 'Spain' },
      { label: 'Netherlands', value: 'Netherlands' },
      { label: 'Belgium', value: 'Belgium' },
      { label: 'Sweden', value: 'Sweden' },
      { label: 'Norway', value: 'Norway' },
      { label: 'Denmark', value: 'Denmark' },
      { label: 'Finland', value: 'Finland' },
      { label: 'Poland', value: 'Poland' },
    ],
  },
  {
    groupLabel: 'Africa',
    options: [
      { label: 'South Africa', value: 'South Africa' },
      { label: 'Egypt', value: 'Egypt' },
      { label: 'Nigeria', value: 'Nigeria' },
      { label: 'Kenya', value: 'Kenya' },
      { label: 'Ethiopia', value: 'Ethiopia' },
      { label: 'Ghana', value: 'Ghana' },
      { label: 'Morocco', value: 'Morocco' },
    ],
  },
  {
    groupLabel: 'Asia',
    options: [
      { label: 'China', value: 'China' },
      { label: 'India', value: 'India' },
      { label: 'Japan', value: 'Japan' },
      { label: 'South Korea', value: 'South Korea' },
      { label: 'Indonesia', value: 'Indonesia' },
      { label: 'Saudi Arabia', value: 'Saudi Arabia' },
      { label: 'United Arab Emirates', value: 'United Arab Emirates' },
      { label: 'Turkey', value: 'Turkey' },
    ],
  },
  {
    groupLabel: 'Oceania',
    options: [
      { label: 'Australia', value: 'Australia' },
      { label: 'New Zealand', value: 'New Zealand' },
      { label: 'Fiji', value: 'Fiji' },
      { label: 'Papua New Guinea', value: 'Papua New Guinea' },
    ],
  },
];

export const countriesWithProvinces = new Set([
  'Canada',
  'Cuba',
  'Dominican Republic',
  'Costa Rica',
  'Panama',
  'Argentina',
  'Ecuador',
  'Netherlands',
  'Belgium',
  'South Africa',
  'China',
  'South Korea',
  'Indonesia',
  'Saudi Arabia',
  'Turkey',
  'Papua New Guinea',
]);

// Canadian Provinces & Territories (with territories at the end)
export const canadianProvincesAndTerritories = [
  // Provinces
  { label: 'Alberta', value: 'Alberta' },
  { label: 'British Columbia', value: 'British Columbia' },
  { label: 'Manitoba', value: 'Manitoba' },
  { label: 'New Brunswick', value: 'New Brunswick' },
  { label: 'Newfoundland and Labrador', value: 'Newfoundland and Labrador' },
  { label: 'Nova Scotia', value: 'Nova Scotia' },
  { label: 'Ontario', value: 'Ontario' },
  { label: 'Prince Edward Island', value: 'Prince Edward Island' },
  { label: 'Quebec', value: 'Quebec' },
  { label: 'Saskatchewan', value: 'Saskatchewan' },
  // Territories (placed last)
  { label: 'Yukon', value: 'Yukon' },
  { label: 'Northwest Territories', value: 'Northwest Territories' },
  { label: 'Nunavut', value: 'Nunavut' },
];

// United States States
export const usStates = [
  { label: 'Alabama', value: 'Alabama' },
  { label: 'Alaska', value: 'Alaska' },
  { label: 'Arizona', value: 'Arizona' },
  { label: 'Arkansas', value: 'Arkansas' },
  { label: 'California', value: 'California' },
  { label: 'Colorado', value: 'Colorado' },
  { label: 'Connecticut', value: 'Connecticut' },
  { label: 'Delaware', value: 'Delaware' },
  { label: 'Florida', value: 'Florida' },
  { label: 'Georgia', value: 'Georgia' },
  { label: 'Hawaii', value: 'Hawaii' },
  { label: 'Idaho', value: 'Idaho' },
  { label: 'Illinois', value: 'Illinois' },
  { label: 'Indiana', value: 'Indiana' },
  { label: 'Iowa', value: 'Iowa' },
  { label: 'Kansas', value: 'Kansas' },
  { label: 'Kentucky', value: 'Kentucky' },
  { label: 'Louisiana', value: 'Louisiana' },
  { label: 'Maine', value: 'Maine' },
  { label: 'Maryland', value: 'Maryland' },
  { label: 'Massachusetts', value: 'Massachusetts' },
  { label: 'Michigan', value: 'Michigan' },
  { label: 'Minnesota', value: 'Minnesota' },
  { label: 'Mississippi', value: 'Mississippi' },
  { label: 'Missouri', value: 'Missouri' },
  { label: 'Montana', value: 'Montana' },
  { label: 'Nebraska', value: 'Nebraska' },
  { label: 'Nevada', value: 'Nevada' },
  { label: 'New Hampshire', value: 'New Hampshire' },
  { label: 'New Jersey', value: 'New Jersey' },
  { label: 'New Mexico', value: 'New Mexico' },
  { label: 'New York', value: 'New York' },
  { label: 'North Carolina', value: 'North Carolina' },
  { label: 'North Dakota', value: 'North Dakota' },
  { label: 'Ohio', value: 'Ohio' },
  { label: 'Oklahoma', value: 'Oklahoma' },
  { label: 'Oregon', value: 'Oregon' },
  { label: 'Pennsylvania', value: 'Pennsylvania' },
  { label: 'Rhode Island', value: 'Rhode Island' },
  { label: 'South Carolina', value: 'South Carolina' },
  { label: 'South Dakota', value: 'South Dakota' },
  { label: 'Tennessee', value: 'Tennessee' },
  { label: 'Texas', value: 'Texas' },
  { label: 'Utah', value: 'Utah' },
  { label: 'Vermont', value: 'Vermont' },
  { label: 'Virginia', value: 'Virginia' },
  { label: 'Washington', value: 'Washington' },
  { label: 'West Virginia', value: 'West Virginia' },
  { label: 'Wisconsin', value: 'Wisconsin' },
  { label: 'Wyoming', value: 'Wyoming' },
];

export const mentorshipTypeDictionary = {
  Paid: 'Paid',
  VolunteerOnly: 'Volunteer Only',
  PaidAndVolunteer: 'Paid and Volunteer',
} as const;

export const mentorshipTypes: SelectOption[] = [
  {
    label: mentorshipTypeDictionary.Paid,
    value: mentorshipTypeDictionary.Paid,
  },
  {
    label: mentorshipTypeDictionary.VolunteerOnly,
    value: mentorshipTypeDictionary.VolunteerOnly,
  },
  {
    label: mentorshipTypeDictionary.PaidAndVolunteer,
    value: mentorshipTypeDictionary.PaidAndVolunteer,
  },
];

export const mentoringSkillsList = [
  // General Career Support
  { label: 'Early Career Coaching', value: 'Early Career Coaching' },
  { label: 'Career Transitioning', value: 'Career Transitioning' },
  { label: 'New Graduate Support', value: 'New Graduate Support' },
  { label: 'Resume Review', value: 'Resume Review' },
  { label: 'Interview Preparation', value: 'Interview Preparation' },
  {
    label: 'Behavioral Interview Coaching',
    value: 'Behavioral Interview Coaching',
  },
  {
    label: 'Technical Interview Preparation',
    value: 'Technical Interview Preparation',
  },
  { label: 'Job Search Strategies', value: 'Job Search Strategies' },
  { label: 'Networking Strategies', value: 'Networking Strategies' },
  {
    label: 'LinkedIn Profile Optimization',
    value: 'LinkedIn Profile Optimization',
  },
  { label: 'Freelancing & Consulting', value: 'Freelancing & Consulting' },
  {
    label: 'Building a Personal Brand in Tech',
    value: 'Building a Personal Brand in Tech',
  },
  { label: 'Soft Skills Development', value: 'Soft Skills Development' },
  { label: 'Communication in Tech', value: 'Communication in Tech' },
  {
    label: 'Public Speaking for Tech Professionals',
    value: 'Public Speaking for Tech Professionals',
  },
  {
    label: 'Workplace Culture & Adaptation',
    value: 'Workplace Culture & Adaptation',
  },
  {
    label: 'Time Management for Engineers',
    value: 'Time Management for Engineers',
  },
  { label: 'Work-Life Balance in Tech', value: 'Work-Life Balance in Tech' },

  // Programming & Development
  { label: 'Frontend Development', value: 'Frontend Development' },
  { label: 'Backend Development', value: 'Backend Development' },
  { label: 'Full Stack Development', value: 'Full Stack Development' },
  {
    label: 'Software Development Lifecycle (SDLC)',
    value: 'Software Development Lifecycle (SDLC)',
  },
  {
    label: 'Object-Oriented Programming (OOP)',
    value: 'Object-Oriented Programming (OOP)',
  },
  { label: 'Functional Programming', value: 'Functional Programming' },
  {
    label: 'Clean Code & Best Practices',
    value: 'Clean Code & Best Practices',
  },
  {
    label: 'Code Reviews & Peer Programming',
    value: 'Code Reviews & Peer Programming',
  },
  {
    label: 'Debugging & Troubleshooting',
    value: 'Debugging & Troubleshooting',
  },
  {
    label: 'Software Performance Optimization',
    value: 'Software Performance Optimization',
  },

  // Programming Languages
  { label: 'Programming: JavaScript', value: 'Programming: JavaScript' },
  { label: 'Programming: TypeScript', value: 'Programming: TypeScript' },
  { label: 'Programming: Python', value: 'Programming: Python' },
  { label: 'Programming: Java', value: 'Programming: Java' },
  { label: 'Programming: C++', value: 'Programming: C++' },
  { label: 'Programming: C#', value: 'Programming: C#' },
  { label: 'Programming: Rust', value: 'Programming: Rust' },
  { label: 'Programming: Go', value: 'Programming: Go' },
  { label: 'Programming: Swift', value: 'Programming: Swift' },
  { label: 'Programming: Kotlin', value: 'Programming: Kotlin' },
  { label: 'Programming: PHP', value: 'Programming: PHP' },
  { label: 'Programming: R', value: 'Programming: R' },
  { label: 'Programming: SQL', value: 'Programming: SQL' },
  {
    label: 'Programming: NoSQL Databases',
    value: 'Programming: NoSQL Databases',
  },
  { label: 'Programming: GraphQL', value: 'Programming: GraphQL' },
  { label: 'Programming: WebAssembly', value: 'Programming: WebAssembly' },
  {
    label: 'Programming: Shell Scripting',
    value: 'Programming: Shell Scripting',
  },

  // Cloud & DevOps
  { label: 'DevOps & CI/CD', value: 'DevOps & CI/CD' },
  {
    label: 'Cloud Computing (AWS, Azure, GCP)',
    value: 'Cloud Computing (AWS, Azure, GCP)',
  },
  {
    label: 'Infrastructure as Code (Terraform, Ansible)',
    value: 'Infrastructure as Code (Terraform, Ansible)',
  },
  {
    label: 'Containerization (Docker, Kubernetes)',
    value: 'Containerization (Docker, Kubernetes)',
  },
  { label: 'Serverless Architectures', value: 'Serverless Architectures' },

  // Cybersecurity
  {
    label: 'Cybersecurity Best Practices',
    value: 'Cybersecurity Best Practices',
  },
  {
    label: 'Ethical Hacking & Penetration Testing',
    value: 'Ethical Hacking & Penetration Testing',
  },
  {
    label: 'Security Compliance & Policies',
    value: 'Security Compliance & Policies',
  },

  // AI & Data Science
  {
    label: 'AI & Machine Learning Fundamentals',
    value: 'AI & Machine Learning Fundamentals',
  },
  { label: 'Data Science & Analytics', value: 'Data Science & Analytics' },
  {
    label: 'Big Data & Distributed Systems',
    value: 'Big Data & Distributed Systems',
  },
  { label: 'Blockchain Development', value: 'Blockchain Development' },

  // Agile & Product Development
  {
    label: 'Agile & Scrum Methodologies',
    value: 'Agile & Scrum Methodologies',
  },
  { label: 'Kanban & Lean Development', value: 'Kanban & Lean Development' },
  {
    label: 'Project Management for Tech',
    value: 'Project Management for Tech',
  },
  { label: 'Product Management in Tech', value: 'Product Management in Tech' },

  // UI/UX & Design
  { label: 'UX/UI Design Principles', value: 'UX/UI Design Principles' },
  {
    label: 'Design Systems & Component Libraries',
    value: 'Design Systems & Component Libraries',
  },
  {
    label: 'Web Accessibility & Inclusive Design',
    value: 'Web Accessibility & Inclusive Design',
  },

  // Entrepreneurship & Innovation
  { label: 'Entrepreneurship in Tech', value: 'Entrepreneurship in Tech' },
  { label: 'Startups & Venture Funding', value: 'Startups & Venture Funding' },
  {
    label: 'Building & Scaling a SaaS Business',
    value: 'Building & Scaling a SaaS Business',
  },
  {
    label: 'Technical Writing & Documentation',
    value: 'Technical Writing & Documentation',
  },

  // Engineering Leadership & Mentorship
  {
    label: 'Technical Leadership & Strategy',
    value: 'Technical Leadership & Strategy',
  },
  { label: 'Managing Technical Teams', value: 'Managing Technical Teams' },
  { label: 'Cross-Team Collaboration', value: 'Cross-Team Collaboration' },
  {
    label: 'Mentorship & Coaching in Tech',
    value: 'Mentorship & Coaching in Tech',
  },
  {
    label: 'Diversity & Inclusion in Tech',
    value: 'Diversity & Inclusion in Tech',
  },
  {
    label: 'Giving & Receiving Feedback',
    value: 'Giving & Receiving Feedback',
  },

  // Other Tech Areas
  { label: 'Game Development', value: 'Game Development' },
  { label: 'Mobile App Development', value: 'Mobile App Development' },
  { label: 'API Design & Development', value: 'API Design & Development' },
  { label: 'RESTful & GraphQL APIs', value: 'RESTful & GraphQL APIs' },
  { label: 'Software Testing & QA', value: 'Software Testing & QA' },
  {
    label: 'Test-Driven Development (TDD)',
    value: 'Test-Driven Development (TDD)',
  },
];

export const genders: SelectOption[] = [
  { value: 'Female', label: 'Female' },
  { value: 'Male', label: 'Male' },
  { value: 'Non-binary', label: 'Non-binary' },
  { value: 'Other', label: 'Other' },
  { value: 'Prefer not to say', label: 'Prefer not to say' },
];

export const races: SelectOption[] = [
  { value: 'Black or African American', label: 'Black or African American' },
  { value: 'Native American', label: 'Native American' },
  { value: 'White', label: 'White' },
  { value: 'Asian', label: 'Asian' },
  { value: 'Pacific Islander', label: 'Pacific Islander' },
  { value: 'Multiracial', label: 'Multiracial' },
  { value: 'Other', label: 'Other' },
  { value: 'Prefer not to say', label: 'Prefer not to say' },
];

export const ageGroups: SelectOption[] = [
  { value: '18-24', label: '18-24' },
  { value: '25-34', label: '25-34' },
  { value: '35-44', label: '35-44' },
  { value: '45-54', label: '45-54' },
  { value: '55-64', label: '55-64' },
  { value: '65+', label: '65+' },
];

export const techSectors = [
  { label: 'Software Development', value: 'Software Development' },
  { label: 'Web Development', value: 'Web Development' },
  { label: 'Mobile App Development', value: 'Mobile App Development' },
  { label: 'Game Development', value: 'Game Development' },
  { label: 'UI/UX Design & Research', value: 'UI/UX Design & Research' },
  {
    label: 'User Experience (UX) Research',
    value: 'User Experience (UX) Research',
  },
  {
    label: 'Human-Computer Interaction (HCI)',
    value: 'Human-Computer Interaction (HCI)',
  },
  { label: 'Product Management', value: 'Product Management' },
  { label: 'Product Design & Strategy', value: 'Product Design & Strategy' },
  { label: 'Cloud Computing', value: 'Cloud Computing' },
  { label: 'Cybersecurity', value: 'Cybersecurity' },
  { label: 'AI & Machine Learning', value: 'AI & Machine Learning' },
  { label: 'Data Science & Analytics', value: 'Data Science & Analytics' },
  {
    label: 'Blockchain & Cryptocurrency',
    value: 'Blockchain & Cryptocurrency',
  },
  { label: 'Internet of Things (IoT)', value: 'Internet of Things (IoT)' },
  { label: 'DevOps & Infrastructure', value: 'DevOps & Infrastructure' },
  {
    label: 'Embedded Systems & Hardware',
    value: 'Embedded Systems & Hardware',
  },
  { label: 'E-Commerce & Retail Tech', value: 'E-Commerce & Retail Tech' },
  { label: 'Healthcare Technology', value: 'Healthcare Technology' },
  {
    label: 'FinTech (Financial Technology)',
    value: 'FinTech (Financial Technology)',
  },
  {
    label: 'EdTech (Education Technology)',
    value: 'EdTech (Education Technology)',
  },
  {
    label: 'AgriTech (Agricultural Technology)',
    value: 'AgriTech (Agricultural Technology)',
  },
  {
    label: 'LegalTech (Legal Technology)',
    value: 'LegalTech (Legal Technology)',
  },
  {
    label: 'PropTech (Real Estate Technology)',
    value: 'PropTech (Real Estate Technology)',
  },
  {
    label: 'InsurTech (Insurance Technology)',
    value: 'InsurTech (Insurance Technology)',
  },
  {
    label: 'MarTech (Marketing Technology)',
    value: 'MarTech (Marketing Technology)',
  },
  {
    label: 'AdTech (Advertising Technology)',
    value: 'AdTech (Advertising Technology)',
  },
  {
    label: 'HRTech (Human Resources Technology)',
    value: 'HRTech (Human Resources Technology)',
  },
  { label: 'Biotech & Life Sciences', value: 'Biotech & Life Sciences' },
  {
    label: 'Augmented Reality (AR) & Virtual Reality (VR)',
    value: 'Augmented Reality (AR) & Virtual Reality (VR)',
  },
  {
    label: 'Autonomous Vehicles & Transportation Tech',
    value: 'Autonomous Vehicles & Transportation Tech',
  },
  { label: '5G & Telecommunications', value: '5G & Telecommunications' },
  { label: 'GreenTech & Sustainability', value: 'GreenTech & Sustainability' },
  { label: 'Robotics & Automation', value: 'Robotics & Automation' },
  { label: 'Media & Entertainment Tech', value: 'Media & Entertainment Tech' },
  { label: 'Gaming & Esports Tech', value: 'Gaming & Esports Tech' },
  { label: 'Smart Cities & Urban Tech', value: 'Smart Cities & Urban Tech' },
  { label: 'Defense & Aerospace Tech', value: 'Defense & Aerospace Tech' },
  { label: 'Wearable Technology', value: 'Wearable Technology' },
  {
    label: 'Technical Writing & Documentation',
    value: 'Technical Writing & Documentation',
  },
  {
    label: 'Open Source & Community Tech',
    value: 'Open Source & Community Tech',
  },
  {
    label: 'Human Factors & Ergonomics in Tech',
    value: 'Human Factors & Ergonomics in Tech',
  },
  {
    label: 'Conversion Rate Optimization (CRO)',
    value: 'Conversion Rate Optimization (CRO)',
  },
];

export const careerStages = [
  { label: 'Student', value: 'Student' },
  { label: 'Intern', value: 'Intern' },
  { label: 'New Graduate', value: 'New Graduate' },
  { label: 'Entry-Level Professional', value: 'Entry-Level Professional' },
  { label: 'Early Career', value: 'Early Career' },
  { label: 'Mid-Level Professional', value: 'Mid-Level Professional' },
  { label: 'Senior Professional', value: 'Senior Professional' },
  { label: 'Lead/Principal Engineer', value: 'Lead/Principal Engineer' },
  { label: 'Manager', value: 'Manager' },
  { label: 'Senior Manager', value: 'Senior Manager' },
  { label: 'Director', value: 'Director' },
  { label: 'Vice President (VP)', value: 'Vice President (VP)' },
  {
    label: 'Executive (C-Level, Founder)',
    value: 'Executive (C-Level, Founder)',
  },
  { label: 'Consultant/Freelancer', value: 'Consultant/Freelancer' },
  { label: 'Career Transitioner', value: 'Career Transitioner' },
  { label: 'Retired/Advisor', value: 'Retired/Advisor' },
];

export const mentoringModels = [
  { label: 'One-on-One', value: 'One-on-One' },
  { label: 'Group', value: 'Group' },
  { label: 'Certification', value: 'Certification' },
];

export const popularLanguages = [
  { label: 'English', value: 'English' },
  { label: 'Mandarin Chinese', value: 'Mandarin Chinese' },
  { label: 'Hindi', value: 'Hindi' },
  { label: 'Spanish', value: 'Spanish' },
  { label: 'French', value: 'French' },
  { label: 'Arabic', value: 'Arabic' },
  { label: 'Bengali', value: 'Bengali' },
  { label: 'Portuguese', value: 'Portuguese' },
  { label: 'Russian', value: 'Russian' },
  { label: 'Urdu', value: 'Urdu' },
  { label: 'Indonesian', value: 'Indonesian' },
  { label: 'German', value: 'German' },
  { label: 'Japanese', value: 'Japanese' },
  { label: 'Swahili', value: 'Swahili' },
  { label: 'Marathi', value: 'Marathi' },
  { label: 'Telugu', value: 'Telugu' },
  { label: 'Turkish', value: 'Turkish' },
  { label: 'Tamil', value: 'Tamil' },
  { label: 'Vietnamese', value: 'Vietnamese' },
  { label: 'Tagalog (Filipino)', value: 'Tagalog (Filipino)' },
  { label: 'Persian (Farsi)', value: 'Persian (Farsi)' },
  { label: 'Italian', value: 'Italian' },
  { label: 'Thai', value: 'Thai' },
  { label: 'Korean', value: 'Korean' },
  { label: 'Polish', value: 'Polish' },
  { label: 'Ukrainian', value: 'Ukrainian' },
  { label: 'Dutch', value: 'Dutch' },
  { label: 'Romanian', value: 'Romanian' },
  { label: 'Greek', value: 'Greek' },
  { label: 'Hebrew', value: 'Hebrew' },
  { label: 'Hungarian', value: 'Hungarian' },
  { label: 'Czech', value: 'Czech' },
  { label: 'Malay', value: 'Malay' },
  { label: 'Burmese', value: 'Burmese' },
  { label: 'Serbian', value: 'Serbian' },
  { label: 'Sinhala', value: 'Sinhala' },
  { label: 'Slovak', value: 'Slovak' },
  { label: 'Bulgarian', value: 'Bulgarian' },
  { label: 'Danish', value: 'Danish' },
  { label: 'Finnish', value: 'Finnish' },
  { label: 'Norwegian', value: 'Norwegian' },
  { label: 'Swedish', value: 'Swedish' },
  { label: 'Lithuanian', value: 'Lithuanian' },
  { label: 'Latvian', value: 'Latvian' },
  { label: 'Estonian', value: 'Estonian' },
  { label: 'Georgian', value: 'Georgian' },
  { label: 'Mongolian', value: 'Mongolian' },
  { label: 'Pashto', value: 'Pashto' },
  { label: 'Hausa', value: 'Hausa' },
  { label: 'Zulu', value: 'Zulu' },
  { label: 'Amharic', value: 'Amharic' },
];

export const employmentStatuses = [
  { label: 'Employed Full-Time', value: 'Employed Full-Time' },
  { label: 'Employed Part-Time', value: 'Employed Part-Time' },
  { label: 'Self-Employed', value: 'Self-Employed' },
  { label: 'Freelancer / Contractor', value: 'Freelancer / Contractor' },
  {
    label: 'Unemployed - Seeking Opportunities',
    value: 'Unemployed - Seeking Opportunities',
  },
  {
    label: 'Unemployed - Not Currently Looking',
    value: 'Unemployed - Not Currently Looking',
  },
  { label: 'Student', value: 'Student' },
  { label: 'Intern', value: 'Intern' },
  { label: 'On Parental Leave', value: 'On Parental Leave' },
  { label: 'On Medical Leave', value: 'On Medical Leave' },
  { label: 'Retired', value: 'Retired' },
  { label: 'Career Transitioning', value: 'Career Transitioning' },
  { label: 'Volunteering', value: 'Volunteering' },
];

export const industries = [
  { label: 'Education', value: 'Education' },
  { label: 'Finance & Banking', value: 'Finance & Banking' },
  {
    label: 'Information Technology (IT)',
    value: 'Information Technology (IT)',
  },
  {
    label: 'Healthcare & Medical Services',
    value: 'Healthcare & Medical Services',
  },
  { label: 'Telecommunications', value: 'Telecommunications' },
  { label: 'Oil & Gas', value: 'Oil & Gas' },
  { label: 'Energy & Utilities', value: 'Energy & Utilities' },
  { label: 'Manufacturing', value: 'Manufacturing' },
  { label: 'Construction & Engineering', value: 'Construction & Engineering' },
  { label: 'Transportation & Logistics', value: 'Transportation & Logistics' },
  { label: 'Retail & E-Commerce', value: 'Retail & E-Commerce' },
  { label: 'Government & Public Sector', value: 'Government & Public Sector' },
  { label: 'Legal Services', value: 'Legal Services' },
  { label: 'Media & Entertainment', value: 'Media & Entertainment' },
  { label: 'Non-Profit & NGOs', value: 'Non-Profit & NGOs' },
  {
    label: 'Real Estate & Property Development',
    value: 'Real Estate & Property Development',
  },
  { label: 'Tourism & Hospitality', value: 'Tourism & Hospitality' },
  { label: 'Agriculture & Agribusiness', value: 'Agriculture & Agribusiness' },
  { label: 'Automotive & Mobility', value: 'Automotive & Mobility' },
  { label: 'Aerospace & Defense', value: 'Aerospace & Defense' },
  {
    label: 'Pharmaceuticals & Biotechnology',
    value: 'Pharmaceuticals & Biotechnology',
  },
  {
    label: 'Consumer Packaged Goods (CPG)',
    value: 'Consumer Packaged Goods (CPG)',
  },
  { label: 'Insurance', value: 'Insurance' },
  { label: 'Cybersecurity', value: 'Cybersecurity' },
  {
    label: 'Environmental Services & Sustainability',
    value: 'Environmental Services & Sustainability',
  },
  {
    label: 'Arts, Culture & Creative Industries',
    value: 'Arts, Culture & Creative Industries',
  },
  { label: 'Food & Beverage', value: 'Food & Beverage' },
  { label: 'Gaming & Interactive Media', value: 'Gaming & Interactive Media' },
  { label: 'Sports & Recreation', value: 'Sports & Recreation' },
  {
    label: 'Space & Satellite Technology',
    value: 'Space & Satellite Technology',
  },
  { label: 'Logistics & Supply Chain', value: 'Logistics & Supply Chain' },
  { label: 'Mining & Natural Resources', value: 'Mining & Natural Resources' },
  {
    label: 'Public Safety & Emergency Services',
    value: 'Public Safety & Emergency Services',
  },
  { label: 'Human Resources & Staffing', value: 'Human Resources & Staffing' },
  {
    label: 'Professional Services (Consulting, Accounting, Legal)',
    value: 'Professional Services (Consulting, Accounting, Legal)',
  },
  {
    label: 'Utilities & Renewable Energy',
    value: 'Utilities & Renewable Energy',
  },
  { label: 'Other / Not Listed', value: 'Other / Not Listed' },
];

export const meetingTimeSlotsOptions = [
  { label: '15 minutes', value: '15' },
  { label: '30 minutes', value: '30' },
  { label: '45 minutes', value: '45' },
  { label: '60 minutes', value: '60' },
  { label: '90 minutes', value: '90' },
  { label: '120 minutes', value: '120' },
];

export const daysOfTheWeek = [
  copy.common.monday,
  copy.common.tuesday,
  copy.common.wednesday,
  copy.common.thursday,
  copy.common.friday,
  copy.common.saturday,
  copy.common.sunday,
];

export const monthsOfTheYear = [
  { label: 'January', value: 1 },
  { label: 'February', value: 2 },
  { label: 'March', value: 3 },
  { label: 'April', value: 4 },
  { label: 'May', value: 5 },
  { label: 'June', value: 6 },
  { label: 'July', value: 7 },
  { label: 'August', value: 8 },
  { label: 'September', value: 9 },
  { label: 'October', value: 10 },
  { label: 'November', value: 11 },
  { label: 'December', value: 12 },
];

export const DAY_NAME_TO_NUM: Record<string, number> = {
  Sunday: 7,
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
};

export const packageTypes = [
  { value: '1:1 Mentorship', label: '1:1 Mentorship', disabled: false },
  {
    value: 'Skills Mentor Membership',
    label: 'Skills Mentor Membership',
    disabled: true,
  },
  {
    value: 'Certification Mentor',
    label: 'Certification Mentor',
    disabled: true,
  },
  { value: 'Career Coach', label: 'Career Coach', disabled: true },
  { value: 'Speed Mentoring', label: 'Speed Mentoring', disabled: true },
];

export const packageStatuses = [
  { value: 'ACTIVE', label: 'Active', disabled: false },
  { value: 'INACTIVE', label: 'Inactive', disabled: false },
  { value: 'ARCHIVED', label: 'Archived', disabled: true },
];

export const cohortFrequencies = [
  { value: 'WEEKLY', label: 'Weekly', disabled: false },
  { value: 'BIWEEKLY', label: 'Biweekly', disabled: false },
  { value: 'MONTHLY', label: 'Monthly', disabled: false },
];

export const cohortStatuses = [
  { value: 'ACTIVE', label: 'Active', disabled: false },
  { value: 'ENROLL_CLOSED', label: 'Enrollment Closed', disabled: false },
  { value: 'INACTIVE', label: 'Inactive', disabled: false },
  { value: 'ARCHIVED', label: 'Archived', disabled: true },
];

export const disputeCategories = [
  { label: 'Payment Issues', value: 'Payment Issues' },
  { label: 'Scheduling & Availability', value: 'Scheduling & Availability' },
  { label: 'Mentorship Quality', value: 'Mentorship Quality' },
  { label: 'Communication Issues', value: 'Communication Issues' },
  { label: 'Platform Issues', value: 'Platform Issues' },
  { label: 'Fraud or Misrepresentation', value: 'Fraud or Misrepresentation' },
  { label: 'Policy Violations', value: 'Policy Violations' },
  { label: 'Other', value: 'Other' },
];
